import React, { Fragment } from 'react';
import { OverlayView } from '@react-google-maps/api';
import { useSelector } from 'react-redux';

import { findLatLngSelector } from '../../../features/map/mapSlice';
import { Chip } from '@mui/material';


const GoogleFindLatLngMarker = ({ map }) => {

    const markerData = useSelector(findLatLngSelector);

    if (markerData) {
        if (markerData.lat && markerData.lng && window.google) {
            return (
                <OverlayView
                    position={{ lat: markerData.lat, lng: markerData.lng }}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <Fragment>
                        <img
                            src={`/assets/history/def30/endflag.png`}
                            alt={"Found Location"}
                            onClick={() => { }}
                        />
                        <Chip
                            size="small"
                            style={{
                                backgroundColor: "white",
                                position: 'absolute',
                                left: -0,
                                top: 35,
                            }}
                            label={<span style={{ color: "Black" }}>Found Location</span>}
                        />
                    </Fragment>
                </OverlayView>
            );
        } else {
            return null;
        }
    } else {
        return null;
    }


}

export default React.memo(GoogleFindLatLngMarker);
